/**
 * Module: `ui-helper/clipboard.ts` — client library utilities.
 * @remarks See exports; keep imports from concrete files when possible.
 */

export const copyToClipboard = async (text: string) => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (error) {
    console.error("Failed to copy to clipboard:", error);
    return false;
  }
};
